/**
 * SMS Consent Configuration Constants
 * Must match backend constants in services/api/src/sms-consent/sms-consent.constants.ts
 */

export const SMS_REACHOUT_PROGRAM_CREDITS = 1000;
